import { gql } from "@apollo/client";

export const UPDATE_PASSWORD = gql`
mutation updatePassword($input: passwordUpdateInput){
    updatePassword(input:$input)
}`